import { render, staticRenderFns } from "./PreviewContainer.vue?vue&type=template&id=6013ba80&scoped=true"
import script from "./PreviewContainer.vue?vue&type=script&lang=ts"
export * from "./PreviewContainer.vue?vue&type=script&lang=ts"
import style0 from "./PreviewContainer.vue?vue&type=style&index=0&id=6013ba80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6013ba80",
  null
  
)

export default component.exports